/*
 * 阶梯赠品 — 用户手动领取 (hs-gift-auto)
 * --------------------------------------
 * 不再后台自动塞赠品（那套有延迟、不稳定）。改为：
 *   - 购物车进度组件里两份赠品始终展示缩略图，达标后出现「Claim gift」按钮（见 snippet hs-bogo-progress）；
 *   - 用户点「Claim gift」→ 立即 /cart/add.js 把赠品加入购物车（即时、无后台延迟）；
 *   - 点缩略图 → 弹出大图 + 「View gift details」按钮（跳赠品商品页）；
 *   - 赠品变 $0 由后台「Buy X Get Y」自动折扣负责。
 *
 * 本脚本职责（都很轻、不在加购关键路径上）：
 *   1) 每次购物车变化 + 页面加载，按「付费件数」同步每张赠品卡片的状态
 *      （锁定 is-locked / 可领取 is-unlocked / 已加入 is-added）和进度条；
 *      （抽屉里进度组件不随购物车事件重渲染，必须靠这里客户端同步。）
 *   2) 处理「Claim gift」按钮点击：加入对应赠品变体，再通知主题重渲染购物车；
 *      以及缩略图点击：弹出赠品大图 + 查看详情链接；
 *   3) 安全网：若购物车里有「当前未达标」的赠品（会被收费），静默移除，避免多收顾客钱。
 *
 * 「付费件数」= 购物车里 final_line_price > 0 且非赠品变体 的行数量之和。
 * 配置来自 window.HS_GIFT_TIERS（见 hs-gift-auto-config / hs-gift-resolve）。
 */
(function () {
  'use strict';

  var TIERS = (window.HS_GIFT_TIERS || [])
    .filter(function (t) {
      return t && t.variantId;
    })
    .sort(function (a, b) {
      return a.threshold - b.threshold;
    });
  if (!TIERS.length) return;

  var GIFT_IDS = TIERS.map(function (t) {
    return Number(t.variantId);
  });

  var addingId = null; // 正在加购的赠品变体，防重复点击

  // 串行化所有会改购物车的请求，避免加购 / 改数量 与赠品 /cart/update 并发导致一侧失败、UI 无反馈。
  var cartWriteChain = Promise.resolve();
  function enqueueCartWrite(task) {
    var run = cartWriteChain.then(task, task);
    cartWriteChain = run.then(
      function () {},
      function () {}
    );
    return run;
  }
  window.hsEnqueueCartWrite = enqueueCartWrite;

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function paidCount(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce(function (sum, line) {
      if (GIFT_IDS.indexOf(Number(line.variant_id)) !== -1) return sum; // 赠品不计入
      return sum + (line.final_line_price > 0 ? line.quantity : 0);
    }, 0);
  }

  function lineFor(cart, variantId) {
    return (cart.items || []).find(function (l) {
      return Number(l.variant_id) === Number(variantId);
    });
  }

  function notifyTheme(cart, claimedVariantId) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'hs-gift-claim',
        cartData: cart || null,
        claimedVariantId: claimedVariantId || null,
      });
    }
  }

  // 领取赠品后拉权威购物车；section 渲染有延迟，必要时短暂重试。
  function getCartAfterClaim(variantId, attempt) {
    attempt = attempt || 0;
    return getCart().then(function (cart) {
      if (lineFor(cart, variantId) || attempt >= 4) return cart;
      return new Promise(function (resolve) {
        setTimeout(resolve, 180);
      }).then(function () {
        return getCartAfterClaim(variantId, attempt + 1);
      });
    });
  }

  // 同步赠品卡片状态 + 进度条（纯 DOM 切换，无购物车写入）。
  function syncCards(cart) {
    var paid = paidCount(cart);
    document.querySelectorAll('.hs-bogo__gift').forEach(function (card) {
      var threshold = parseInt(card.getAttribute('data-threshold'), 10);
      var vid = card.getAttribute('data-variant-id');
      var inCart = !!lineFor(cart, vid);
      card.classList.remove('is-locked', 'is-unlocked', 'is-added');
      if (inCart) {
        card.classList.add('is-added');
      } else if (!Number.isNaN(threshold) && paid >= threshold) {
        card.classList.add('is-unlocked');
      } else {
        card.classList.add('is-locked');
      }
    });
    if (typeof window.hsSyncBogoProgress === 'function') window.hsSyncBogoProgress(paid);
  }
  window.hsGiftSyncCards = syncCards;

  // 安全网：移除「当前付费件数已达不到其门槛」的赠品行（避免被当原价收费）。
  // 返回是否真的移除了东西。调用方负责重渲染（避免与 /cart/change 并发写购物车）。
  function removeUnqualifiedGifts(cart) {
    var paid = paidCount(cart);
    var updates = {};
    var any = false;
    TIERS.forEach(function (t) {
      var line = lineFor(cart, t.variantId);
      if (line && paid < t.threshold) {
        updates[String(t.variantId)] = 0;
        any = true;
      }
    });
    if (!any) return Promise.resolve(false);
    return enqueueCartWrite(function () {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates }),
      })
        .then(function (r) {
          return r.ok;
        })
        .catch(function () {
          return false;
        });
    });
  }

  // 供 cart.js 在改数量/删除后 await：同步卡片 + 必要时移出不合格赠品。
  // 不在这里 publish，避免与 cart.js 的刷新流程抢跑；返回是否移除了赠品。
  window.hsReconcileGifts = function (cart) {
    if (!cart || !Array.isArray(cart.items)) return Promise.resolve(false);
    syncCards(cart);
    return removeUnqualifiedGifts(cart).then(function (removed) {
      if (!removed) return false;
      return getCart()
        .then(function (fresh) {
          syncCards(fresh);
          return true;
        })
        .catch(function () {
          return true;
        });
    });
  };

  // 处理一次购物车快照：同步卡片；非本脚本触发时再跑安全网移除。
  function handleCart(cart, fromSelf) {
    syncCards(cart);
    if (fromSelf) return Promise.resolve(false);
    return removeUnqualifiedGifts(cart).then(function (removed) {
      if (removed) notifyTheme(); // 让主题重渲染掉那条赠品行
      return removed;
    });
  }

  // 「Add free gift」点击（事件委托，兼容组件被重渲染）。
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-hs-add-gift]');
    if (!btn) return;
    event.preventDefault();
    var card = btn.closest('.hs-bogo__gift');
    if (!card) return;
    var variantId = Number(card.getAttribute('data-variant-id'));
    if (!variantId || addingId === variantId) return;

    addingId = variantId;
    btn.setAttribute('disabled', '');
    // 乐观更新：避免 add 成功但 cart.js 短暂滞后时按钮仍显示 Claim gift。
    card.classList.remove('is-locked', 'is-unlocked');
    card.classList.add('is-added');

    enqueueCartWrite(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname || '/',
        }),
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      });
    })
      .then(function (response) {
        // 优先用加车返回的 sections 立刻画上赠品行（与商详加购同路径），避免再等 section 轮询 2s+。
        var painted = false;
        var drawer = document.querySelector('cart-drawer');
        var sectionHtml = response && response.sections && response.sections['cart-drawer'];
        if (drawer && sectionHtml && sectionHtml.indexOf(String(variantId)) !== -1) {
          drawer.renderContents(response);
          painted = true;
        }

        return getCartAfterClaim(variantId).then(function (cart) {
          syncCards(cart);
          if (painted) {
            // 已画过：只通知订阅者同步卡片，避免 renderFreshSections 用滞后 HTML 盖掉赠品行。
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'hs-gift-claim',
                cartData: cart,
                claimedVariantId: variantId,
                sectionsPainted: true,
              });
            }
          } else {
            notifyTheme(cart, variantId); // 回退：让 cart.js 轮询到赠品行出现再渲染
          }
        });
      })
      .catch(function () {
        getCart()
          .then(syncCards)
          .catch(function () {});
      })
      .then(function () {
        addingId = null;
        btn.removeAttribute('disabled');
      });
  });

  // 礼物大图弹窗：点缩略图 → 展示大图 + 「View gift details」按钮（跳赠品商品页，新标签）。
  var giftModal = null;
  function buildModal() {
    if (giftModal) return giftModal;
    var m = document.createElement('div');
    m.className = 'hs-gift-modal';
    m.innerHTML =
      '<div class="hs-gift-modal__backdrop" data-hs-gift-close></div>' +
      '<div class="hs-gift-modal__card" role="dialog" aria-modal="true" aria-label="Free gift details">' +
      '<button type="button" class="hs-gift-modal__close" data-hs-gift-close aria-label="Close">\u00d7</button>' +
      '<img class="hs-gift-modal__img" alt="">' +
      '<span class="hs-gift-modal__free">FREE GIFT</span>' +
      '<h3 class="hs-gift-modal__title"></h3>' +
      '<p class="hs-gift-modal__desc"></p>' +
      '<a class="hs-gift-modal__link" href="#" target="_blank" rel="noopener">View gift details</a>' +
      '</div>';
    document.body.appendChild(m);
    m.addEventListener('click', function (e) {
      if (e.target.closest('[data-hs-gift-close]')) closeModal();
    });
    giftModal = m;
    return m;
  }

  function openModalFromCard(card) {
    var m = buildModal();
    var img = m.querySelector('.hs-gift-modal__img');
    var link = m.querySelector('.hs-gift-modal__link');
    var imgUrl = card.getAttribute('data-img') || '';
    var url = card.getAttribute('data-url') || '';
    if (imgUrl) {
      img.src = imgUrl;
      img.style.display = '';
    } else {
      img.removeAttribute('src');
      img.style.display = 'none';
    }
    img.alt = card.getAttribute('data-title') || '';
    m.querySelector('.hs-gift-modal__title').textContent = card.getAttribute('data-title') || 'Free gift';
    m.querySelector('.hs-gift-modal__desc').textContent = card.getAttribute('data-desc') || '';
    if (url) {
      link.href = url;
      link.style.display = '';
    } else {
      link.style.display = 'none';
    }
    m.classList.add('is-open');
  }

  function closeModal() {
    if (giftModal) giftModal.classList.remove('is-open');
  }

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-hs-gift-thumb]');
    if (!thumb) return;
    event.preventDefault();
    var card = thumb.closest('.hs-bogo__gift');
    if (card) openModalFromCard(card);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeModal();
  });

  // 监听主题购物车事件（加车/改数量/删除/quick-add 都会 publish cartUpdate）。
  // 注意：source === 'cart-items' 时只同步卡片 UI——移出不合格赠品由 cart.js
  // 通过 window.hsReconcileGifts await，避免 /cart/change 与 /cart/update 并发竞态。
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var fromSelf = event && event.source === 'hs-gift-claim';
      var fromCartItems = event && event.source === 'cart-items';

      if (fromCartItems) {
        if (event.cartData && Array.isArray(event.cartData.items)) syncCards(event.cartData);
        return;
      }

      // 优先用事件里带的 cartData，省一次请求；没有就拉一次。
      if (event && event.cartData && Array.isArray(event.cartData.items)) {
        handleCart(event.cartData, fromSelf);
      } else {
        getCart()
          .then(function (cart) {
            return handleCart(cart, fromSelf);
          })
          .catch(function () {});
      }
    });
  }

  // 页面加载对账一次（同步卡片 + 安全网）。
  function init() {
    getCart()
      .then(function (cart) {
        return handleCart(cart, false);
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
